import { memo } from "react";
import { PlainMessageBody } from "./PlainMessageBody";
import { TipTapMessageBody } from "./TipTapMessageBody";

export interface ContentBodyProps {
  isPinnedMessageAtTop?: boolean;
  message: any;
  shouldScrollIntoView?: boolean;
  shouldShowPreviewBlocks?: boolean;
}

const isRichTextBodyContentEmpty = (richTextBody: any) => {
  if (!richTextBody) {
    return true;
  }
  const { body } = richTextBody;
  const { content } = body;
  return content.length === 0;
};

export const ContentBody = memo(
  ({
    message,
    shouldScrollIntoView = false,
    isPinnedMessageAtTop = false,
    shouldShowPreviewBlocks = true,
  }: ContentBodyProps) => {
    const shouldShowRichTextBody: boolean = isPinnedMessageAtTop
      ? !isRichTextBodyContentEmpty(message.rich_text_body)
      : Boolean(message.rich_text_body);

    if (shouldShowRichTextBody) {
      return (
        <TipTapMessageBody
          rich_text_body={message.rich_text_body}
          shouldScrollIntoView={shouldScrollIntoView}
          isPinnedMessageAtTop={isPinnedMessageAtTop}
          editedAt={message.edited_at}
          chatRoomAccessArr={message.embedded_chat_message_access}
          shouldShowPreviewBlocks={shouldShowPreviewBlocks}
          chatProps={{
            unfurlUrls: message.unfurl_urls,
          }}
        />
      );
    }
    return (
      <PlainMessageBody
        body={message.body}
        isPinnedMessageAtTop={isPinnedMessageAtTop}
      />
    );
  },
);

ContentBody.displayName = "ContentBody";
